import LessonSummary from './lessons/LessonSummary.vue'
import LessonSearch from './lessons/LessonSearch.vue'
import RelatedLessons from './lessons/RelatedLessons.vue'
import PathSummary from './paths/PathSummary.vue'
import PathLessons from './paths/PathLessons.vue'
import PathSearch from './paths/PathSearch.vue'
import PathTitle from '~/components/externalContent/lessons/PathTitle.vue'

export default [
  LessonSearch,
  LessonSummary,
  PathLessons,
  PathSearch,
  PathSummary,
  RelatedLessons,
  PathTitle,
]
